function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { useTheme } from "../../ThemeProvider/useTheme";
import { validateLength } from "../utils";
import { css } from "@emotion/react";
var buildStyle = function(param, param1) {
    var font = param.font, backgroundColor = param.backgroundColor, size = param.size, borderColor = param.borderColor, depth = param.depth, readingDirection = param1.readingDirection;
    return {
        outerContainer: {
            base: _objectSpread({}, readingDirection, {
                fontFamily: font.base.family,
                color: font.color.base,
                display: 'flex',
                overflow: 'hidden',
                borderRadius: size.border.radius.fiveX,
                backgroundColor: backgroundColor.base
            }),
            border: {
                border: "".concat(size.border.base, "px solid ").concat(borderColor.soft)
            },
            horizontal: {
                base: {
                    flexDirection: 'row'
                },
                rtl: {
                    flexDirection: 'row-reverse'
                },
                responsive: {
                    width: '100%'
                }
            },
            vertical: {
                base: {
                    flexWrap: 'wrap'
                },
                fixedWidth: {
                    height: '100%'
                },
                responsive: {
                    height: '100%',
                    width: '100%'
                }
            }
        }
    };
};
export default function useStyle(param) {
    var orientation = param.orientation, responsive = param.responsive, width = param.width, height = param.height, isRtl = param.isRtl, hasBorder = param.hasBorder, elevation = param.elevation;
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    var ref = useTheme(), boxShadow = ref.depth.boxShadow;
    if (!builtStyle) {
        return {
            outerContainerStyle: css({})
        };
    }
    var shadow = {
        boxShadow: "".concat(boxShadow[elevation].xOffset, "\n      ").concat(boxShadow[elevation].yOffset, "\n      ").concat(boxShadow[elevation].blurRadius, "\n      ").concat(boxShadow[elevation].spreadRadius, "\n      ").concat(boxShadow[elevation].color)
    };
    var outerContainer = builtStyle.outerContainer;
    return {
        outerContainerStyle: css(_objectSpread({}, outerContainer.base, hasBorder && outerContainer.border, shadow, orientation === 'horizontal' ? _objectSpread({}, isRtl ? _objectSpread({}, outerContainer.horizontal.rtl) : _objectSpread({}, outerContainer.horizontal.base), responsive ? _objectSpread({}, outerContainer.horizontal.responsive, typeof height !== 'undefined' && {
            maxHeight: validateLength(height, 'height')
        }) : _objectSpread({
            width: width
        }, typeof height !== 'undefined' && {
            maxHeight: validateLength(height, 'height')
        })) : _objectSpread({}, outerContainer.vertical.base, responsive ? _objectSpread({}, outerContainer.vertical.responsive, typeof height !== 'undefined' && {
            maxHeight: validateLength(height, 'height')
        }) : _objectSpread({}, outerContainer.vertical.fixedWidth, typeof height !== 'undefined' && {
            maxHeight: validateLength(height, 'height')
        }, typeof width !== 'undefined' && {
            width: validateLength(width, 'width')
        }))))
    };
};
